jQuery(document).ready(function($){

  function alThemeString(key, fallback) {
    return window.theme && theme.strings && theme.strings[key] ? theme.strings[key] : fallback;
  }

  /************************ Customize Product **************************/

  const hasProgressbar = $(".customize-base-grid").attr('data-has-addon');
  const included = $(".customize-base-grid").attr('data-included-addon');

  let count = 0;
  let total_price = 0;
  var free_stone_1;
  var free_stone_2;

  var cage_selected = false;
  
  var free_extra_stones = 0;

  var free_stone = included;

  var single_stone_price = '';

  if($('ul.customize-addon-variants').length > 0){
    $('ul.customize-addon-variants li').each(function(){
      if($(this).find('input[data-price-not-zero]').length > 0){
        single_stone_price = $(this).find('input[data-price-not-zero]').attr('data-price');
      }
    })
  }

  free_stone_1 = parseInt($(".customize-base-grid").attr('data-first-free-addon'));
  free_stone_2 = parseInt($(".customize-base-grid").attr('data-second-free-addon'));

  
  if(hasProgressbar == "true") {
    
    const total = parseInt(included) + parseInt(free_stone_1) + parseInt(free_stone_2);
    
    const progress1 = document.querySelector(".progress-step1");
    const progress2 = document.querySelector(".progress-step2");
    const progress3 = document.querySelector(".progress-step3");
    const progress_done1 = document.querySelector(".progress-done1");
    const progress_done2 = document.querySelector(".progress-done2");
    const progress_done3 = document.querySelector(".progress-done3");

    const gift = document.getElementById("freestones");
    const stone1 = document.getElementById("stone1");
    const stone2 = document.getElementById("stone2");

    progress_done1.style.opacity = 1;
    progress_done2.style.opacity = 1;
    progress_done3.style.opacity = 1;

    progress1.style.width = (included / total) * 100 + "%";
    progress2.style.width = (free_stone_1 / total) * 100 + "%";
    progress3.style.width = (free_stone_2 / total) * 100 + "%";

    // Render popup of error and free stones
    function renderPopup() {
      if (count == parseInt(included) + parseInt(free_stone_1)){
        $("#popUp2").show();
        setTimeout(function () {
          $("#popUp2").hide();
        }, 1000);
      } else if (count == parseInt(included) + parseInt(free_stone_1) + parseInt(free_stone_2)){
        $("#popUp2").show();
        setTimeout(function () {
          $("#popUp2").hide();
        }, 1000);
      } else if (count > included) {
        $("#popUp").text('+ '+single_stone_price+' CHF');
        $("#popUp").show();
        setTimeout(function () {
          $("#popUp").hide();
          $("#popUp").text('');
        }, 1000);
      }
    }

    //Popup Alert if cage not selected
    function renderPopupAlert(){
      $("#popUpAlert").show();
      setTimeout(function (){
        $("#popUpAlert").hide();
      }, 4000);
    }

    // Render progress when addon is added
    function renderProgressAdd() {
      if (count == included) {
        setTimeout(() => {
          gift.classList.add("active");
        }, 1000);
      } else if(count == parseInt(included) + parseInt(free_stone_1)) {
        stone1.classList.add("active");
        stone1.classList.add("wiggleIcon");
      } else if (count == total) {
        stone2.classList.add("active");
        stone2.classList.add("wiggleIcon");
      }
      console.log("total:", total);
      console.log("count:", count);

      if (count <= included) {
        progress_done1.style.width = parseFloat(count * 100) / parseFloat(included) + "%";
      }else if(count < parseInt(included) + parseInt(free_stone_1)){
        progress_done2.style.width =
          ((count - included) * 100) / (free_stone_1 - 1) + "%";
      } else if(count < total) {
        progress_done3.style.width =
          ((count - included - free_stone_1) * 100) / (free_stone_2 - 1) + "%";
      } else {
      }
    }

    // Render progress when addon is removed
    function renderProgressSub() {
      if (count < included) {
        setTimeout(() => {
          gift.classList.remove("active");
        }, 0);
      } else if (count < parseInt(included) + parseInt(free_stone_1)) {
        setTimeout(() => {
          stone1.classList.remove("active");
          stone1.classList.remove("wiggleIcon");
        }, 0);
      } else if (count < total) {
        setTimeout(() => {
          stone2.classList.remove("active");
          stone2.classList.remove("wiggleIcon");
        }, 0);
      }
      console.log("total:", total);
      console.log("count:", count);
      // Check which progress step
      if (count < included) {
        progress_done1.style.width = (count * 100) / included + "%";
      } else if (count < parseInt(included) + parseInt(free_stone_1)) {
        progress_done2.style.width =
          ((count - included) * 100) / (free_stone_1 - 1) + "%";
      } else if (count < total) {
        progress_done3.style.width =
          ((count - included - free_stone_1) * 100) / (free_stone_2 - 1) + "%";
      } else {
      }
    }

    // Clear progress of progressbar
    function renderProgressClear() {
      gift.classList.remove("active");
      stone1.classList.remove("active");
      stone1.classList.remove("wiggleIcon");
      stone2.classList.remove("active");
      stone2.classList.remove("wiggleIcon");
      // Check which progress step
      progress_done1.style.width = 0 + "%";
      progress_done2.style.width = 0 + "%";
      progress_done3.style.width = 0 + "%";
    }

  } 


  // Select cage
  $('.customize_product_base .customize_base_inner.customize_base_select_section .customize-base-box label').on('click', function(e){
    e.preventDefault();
    $('customize_product_base .customize_base_inner.customize_base_select_section .customize-base-box input[type="radio"]').prop('checked', false);
    $(this).closest(' .customize-base-box').find('input[type="radio"]').prop('checked', true);
    $(this).addClass('active');
    $(this).closest('.customize-base-box').addClass('is-selected');
    var base_price = $(this).closest(' .customize-base-box').find('input[type="radio"]').attr('data-price');
    $('.customize-product-price-grid .customize_product_price').html('CHF'+base_price);
    $('.customize-product-price-grid .customize_product_price').attr('data-new-price',base_price);
    $('.customize-product-price-grid').show();
    cage_selected = true;
  })

  // Add stones to list
  $('.customize-base-grid .customize-base-inner .customize-box label.customize-addon-label').on('click', function(e){
    e.preventDefault();
    var val = ''; var price = ''; var check_if_base_selected = 0; var new_price = 0; var check_for_nostone = 0; var vid = '';
    var total = 0;
    var main_price = $('.customize-product-price-grid .customize_product_price').attr('data-base-price');
    $(this).addClass('active');
  
    if(!cage_selected){
      console.log("select cage first");
      renderPopupAlert();
    }else{
      if(hasProgressbar == "true"){
          count += 1;
          renderProgressAdd();
          renderPopup();
      }
      if($(this).closest('.customize-box').hasClass('no-stone')){
          count = 0;
          if (hasProgressbar == "true") {
              renderProgressClear();
          }
          var var_price = 0;
          var_price =  $('.customize_product_base .customize-base-box input[type="radio"]:checked').attr('data-price');
          
          var new_price = parseFloat(var_price).toFixed(2);
          total_price = new_price;
          console.log(new_price);
          var currency_symbol = 'CHF';
          $(".customize-product-price-grid .customize_product_price").html(currency_symbol + new_price);
          $(".selected_stone").html("");
      }else{
          $(".customize-box.no-stone .customize-addon-label").removeClass("active");
          var total = 0;
          $(".selected_stone li .quan_").each(function () {
            total = parseFloat(total) + parseFloat($(this).html());
          });
          if(total < free_stone){
              var val_name = $(this).closest(' .customize-box').find('.customize-addon-variants li input[data-price-zero]').attr('data-name');
              var val_handle = $(this).closest(' .customize-box').find('.customize-addon-variants li input[data-price-zero]').attr('data-handle');
              var vid = $(this).closest(' .customize-box').find('.customize-addon-variants li input[data-price-zero]').val();
			  
              if ($(".selected_stone ." + val_handle).length > 0) {
                  var old_qun = $(".selected_stone ." + val_handle + " .quan_").html();
                  var new_quan = parseFloat(old_qun) + 1;
                  $(".selected_stone ." + val_handle + " .quan_").html(new_quan);
                  $(".selected_stone ." + val_handle).attr('data-qty0', parseInt($(".selected_stone ." + val_handle).attr('data-qty0')) + parseInt(1));
                  $(".selected_stone ." + val_handle).attr('data-id0', vid);
                  $(this).closest(' .customize-box').find('.customize-addon-variants li input[data-price-zero]:checked').prop("checked", false);
                  $("button#add_stone").hide();
              }else{
                  $(this).closest(' .customize-box').find('.customize-addon-variants li input[data-price-zero]:checked').prop("checked", false);
                  $("button#add_stone").hide();
                  $(".selected_stone").append(
                      '<li data-qty0="1" data-id0="'+vid+'" data-qty1="0" data-id1="" class="' +
                      val_handle +
                      '"><span class="name">' +
                      val_name +
                      '</span><span class="stone_quan"><span class="minus">-</span><span class="quan_">1</span><span class="plus_">+</span></span></li>'
                  );
              }
              var var_price = 0;
              var var_price =  $('.customize_product_base .customize-base-box input[type="radio"]:checked').attr('data-price');
              var new_price = parseFloat(var_price).toFixed(2);
              var currency_symbol = 'CHF';
              $(".customize-product-price-grid .customize_product_price").html(currency_symbol + new_price);
          }else{
              if(count == parseInt(included)+parseInt(free_stone_1)){
                var val_name = $(this).closest(' .customize-box').find('.customize-addon-variants li input[data-price-zero]').attr('data-name');
				var val_handle = $(this).closest(' .customize-box').find('.customize-addon-variants li input[data-price-zero]').attr('data-handle');
                var vid = $(this).closest(' .customize-box').find('.customize-addon-variants li input[data-price-zero]').val();

                if ($(".selected_stone ." + val_handle).length > 0) {
                  var old_qun = $(".selected_stone ." + val_handle + " .quan_").html();
                  var new_quan = parseFloat(old_qun) + 1;
                  $(".selected_stone ." + val_handle + " .quan_").html(new_quan);
                  $(".selected_stone ." + val_handle).attr('data-qty0', parseInt($(".selected_stone ." + val_handle).attr('data-qty0'))+parseInt(1));
                  $(".selected_stone ." + val_handle).attr('data-id0', vid);
                  $(this).closest(' .customize-box').find('.customize-addon-variants li input[data-price-zero]:checked').prop("checked", false);
                  $("button#add_stone").hide();
                }else{
                  $(this).closest(' .customize-box').find('.customize-addon-variants li input[data-price-zero]:checked').prop("checked", false);
                  $("button#add_stone").hide();
                  $(".selected_stone").append(
                      '<li data-qty0="1" data-id0="'+vid+'" data-qty1="0" data-id1="" class="' +
                      val_handle +
                      '"><span class="name">' +
                      val_name +
                      '</span><span class="stone_quan"><span class="minus">-</span><span class="quan_">1</span><span class="plus_">+</span></span></li>'
                  );
                }
              }else if(count == parseInt(included) + parseInt(free_stone_1) + parseInt(free_stone_2)){
                var val_name = $(this).closest(' .customize-box').find('.customize-addon-variants li input[data-price-zero]').attr('data-name');
				var val_handle = $(this).closest(' .customize-box').find('.customize-addon-variants li input[data-price-zero]').attr('data-handle');
                var vid = $(this).closest(' .customize-box').find('.customize-addon-variants li input[data-price-zero]').val();
                
                if ($(".selected_stone ." + val_handle).length > 0) {
                  var old_qun = $(".selected_stone ." + val_handle + " .quan_").html();
                  var new_quan = parseFloat(old_qun) + 1;
                  $(".selected_stone ." + val_handle + " .quan_").html(new_quan);
                  $(".selected_stone ." + val_handle).attr('data-qty0', parseInt($(".selected_stone ." + val_handle).attr('data-qty0'))+parseInt(1));
                  $(".selected_stone ." + val_handle).attr('data-id0', vid);
                  $(this).closest(' .customize-box').find('.customize-addon-variants li input[data-price-zero]:checked').prop("checked", false);
                  $("button#add_stone").hide();
                }else{
                  $(this).closest(' .customize-box').find('.customize-addon-variants li input[data-price-zero]:checked').prop("checked", false);
                  $("button#add_stone").hide();
                  $(".selected_stone").append(
                      '<li data-qty0="1" data-id0="'+vid+'" data-qty1="0" data-id1="" class="' +
                      val_handle +
                      '"><span class="name">' +
                      val_name +
                      '</span><span class="stone_quan"><span class="minus">-</span><span class="quan_">1</span><span class="plus_">+</span></span></li>'
                  );
                }
              }else{
                var val_name = $(this).closest(' .customize-box').find('.customize-addon-variants li input[data-price-not-zero]').attr('data-name');
				var val_handle = $(this).closest(' .customize-box').find('.customize-addon-variants li input[data-price-zero]').attr('data-handle');
                var vid = $(this).closest(' .customize-box').find('.customize-addon-variants li input[data-price-not-zero]').val();
                
                if ($(".selected_stone ." + val_handle).length > 0) {
                  var old_qun = $(".selected_stone ." + val_handle + " .quan_").html();
                  var new_quan = parseFloat(old_qun) + 1;
                  $(".selected_stone ." + val_handle + " .quan_").html(new_quan);
                  $(".selected_stone ." + val_handle).attr('data-qty1', parseInt($(".selected_stone ." + val_handle).attr('data-qty1')) + parseInt(1));
                  $(".selected_stone ." + val_handle).attr('data-id1', vid);
                  $(this).closest(' .customize-box').find('.customize-addon-variants li input[data-price-not-zero]:checked').prop("checked", false);
                  $("button#add_stone").hide();
                }else{
                  $(this).closest(' .customize-box').find('.customize-addon-variants li input[data-price-not-zero]:checked').prop("checked", false);
                  $("button#add_stone").hide();
                  $(".selected_stone").append(
                      '<li data-qty0="0" data-id0="" data-qty1="1" data-id1="'+vid+'" class="' +
                      val_handle +
                      '"><span class="name">' +
                      val_name +
                      '</span><span class="stone_quan"><span class="minus">-</span><span class="quan_">1</span><span class="plus_">+</span></span></li>'
                  );
                }
              }
            
              var var_price = 0;
              var var_price = $('.customize_product_base .customize-base-box input[type="radio"]:checked').attr('data-price');
              total = parseFloat(total) + 1;
              if(hasProgressbar == "true") {
                  if (count >= parseInt(included) + parseInt(free_stone_1) + parseInt(free_stone_2)){
                      free_extra_stones = 2;
                  }else if (count >= parseInt(included) + parseInt(free_stone_1)){
                      free_extra_stones = 1;
                  }
              }
              var new_total = parseFloat(total) - parseFloat(free_stone) - parseFloat(free_extra_stones);
              var stone_price = parseFloat(new_total) * parseFloat(single_stone_price);
              var new_price = (parseFloat(stone_price) + parseFloat(var_price)).toFixed(2);
              total_price = new_price;
              var currency_symbol = 'CHF';
              $(".customize-product-price-grid .customize_product_price").html(currency_symbol + new_price);
          }
      }
      if ($(window).width() <= 767){
          var inpuid = $(this).attr("id");
          $(".info.hide").each(function (){
              $(this).css("visibility", "hidden");
          });
          $('label[for="' + inpuid + '"] .info.hide').css(
          "visibility",
          "visible"
          );
      }
    }
  })


  /*********************************** For Removing Selected Stone ************************************************/
  $(document).on("click", ".selected_stone li .minus", function () {
    var old_val = $(this).parent().find(".quan_").html();
    var data_name = $(this).closest('li').attr('class');
    count -= 1;
    if (hasProgressbar == "true") {
      if(count <= parseInt(included) + parseInt(free_stone_1) + parseInt(free_stone_2)){
        renderProgressSub();
      }
    }
    if(old_val == 1){
      $(this).closest("li").remove();
    }else{
      var new_quan = parseFloat(old_val) - 1;
      $(this).parent().find(".quan_").html(new_quan);
    }
    var total = 0;
    $(".selected_stone li .quan_").each(function () {
      total = parseFloat(total) + parseFloat($(this).html());
    });
    var var_price = 0;
    var base_price = $(".customize_product_base .customize-base-box.is-selected").find('input[type="radio"]').attr('data-price');
    var_price = base_price;
    // var var_price = $(".customize-product-price-grid .customize_product_price").attr("data-base-price");

    var check_if_id_exists0 = $(this).closest('li').attr('data-id0');
    var check_if_id_exists1 = $(this).closest('li').attr('data-id1');
    var check_if_qty0 = $(this).closest('li').attr('data-qty0');
    var check_if_qty1 = $(this).closest('li').attr('data-qty1');

    if(total < free_stone){
      var vid0 = '';
      $('.customize-base-grid .customize-box').each(function(){
        if($(this).find('.customize-addon-label').attr('data-handle') == data_name){
          vid0 = $(this).find('.customize-addon-variants li input[data-price-zero]').val();
        }
      }) 
      var updated_qty0 = 0;
      if(check_if_qty0 != 'undefined'){
        if(check_if_qty0 > 0){
          updated_qty0 = parseInt(check_if_qty0)-parseInt(1); 
        }else{
          updated_qty0 = 1; 
        }
        $(this).closest('li').attr('data-qty0',updated_qty0);
        $(this).closest('li').attr('data-id0',vid0);
      }
      
    }else if(total > free_stone && total == parseInt(included) + parseInt(free_stone_1) - parseInt(1)){
      var vid0 = ''; var vid1 = '';
       $('.customize-base-grid .customize-box').each(function(){
        if($(this).find('.customize-addon-label').attr('data-handle') == data_name){
          vid0 = $(this).find('.customize-addon-variants li input[data-price-zero]').val();
          vid1 = $(this).find('.customize-addon-variants li input[data-price-not-zero]').val();
        }
      }) 
      var updated_qty0 = 0;
      if(check_if_qty0 != 'undefined'){
        if(check_if_qty0 > 0){
          updated_qty0 = parseInt(check_if_qty0)-parseInt(1); 
        }else{
          updated_qty0 = 1; 
        }
        $(this).closest('li').attr('data-qty0',updated_qty0);
        $(this).closest('li').attr('data-id0',vid0);
      }
    }else if(total > free_stone && total == parseInt(included) + parseInt(free_stone_1) + parseInt(free_stone_2) - parseInt(1)){
      var vid0 = ''; var vid1 = '';
       $('.customize-base-grid .customize-box').each(function(){
        if($(this).find('.customize-addon-label').attr('data-handle') == data_name){
          vid0 = $(this).find('.customize-addon-variants li input[data-price-zero]').val();
          vid1 = $(this).find('.customize-addon-variants li input[data-price-not-zero]').val();
        }
      }) 
      var updated_qty0 = 0;
      if(check_if_qty0 != 'undefined'){
        if(check_if_qty0 > 0){
          updated_qty0 = parseInt(check_if_qty0)-parseInt(1); 
        }else{
          updated_qty0 = 1; 
        }
        $(this).closest('li').attr('data-qty0',updated_qty0);
        $(this).closest('li').attr('data-id0',vid0);
      }
    }else{
      var vid0 = ''; var vid1 = '';
      $('.customize-base-grid .customize-box').each(function(){
        if($(this).find('.customize-addon-label').attr('data-handle') == data_name){
          vid0 = $(this).find('.customize-addon-variants li input[data-price-zero]').val();
          vid1 = $(this).find('.customize-addon-variants li input[data-price-not-zero]').val();
        }
      }) 
      var updated_qty1 = 0; var updated_qty0 = 0;
      if(total > free_stone){
        if(check_if_qty1 != 'undefined' && check_if_qty1 > 0){
          updated_qty1 = parseInt(check_if_qty1)-parseInt(1); 
          $(this).closest('li').attr('data-qty1',updated_qty1);
          $(this).closest('li').attr('data-id1',vid1);
        }else if(check_if_qty0 != 'undefined' && check_if_qty0 > 0 && check_if_qty1 == 0){
          updated_qty0 = parseInt(check_if_qty0)-parseInt(1); 
          $(this).closest('li').attr('data-qty0',updated_qty0);
          $(this).closest('li').attr('data-id0',vid0);
        }
      }else if(total == free_stone){
        if(check_if_qty0 != 'undefined' && check_if_qty0 > 0 && check_if_qty1 == 0){
          updated_qty0 = parseInt(check_if_qty0)-parseInt(1); 
          $(this).closest('li').attr('data-qty0',updated_qty0);
          $(this).closest('li').attr('data-id0',vid0);
        }else if(check_if_qty1 > 0){
          updated_qty1 = parseInt(check_if_qty1)-parseInt(1);
          $(this).closest('li').attr('data-qty1',updated_qty1);
          $(this).closest('li').attr('data-id1',vid1);
        } 
        $(".selected_stone li").each(function(){
          var qty1 = $(this).attr('data-qty1');
          var qty0 = $(this).attr('data-qty0'); 
          if($(this).attr('data-qty1') != 'undefined'){
           $(this).attr('data-qty1', 0);
           $(this).attr('data-id1', '');
          } 
          if($(this).attr('data-qty0') != 'undefined'){
           if(qty1 > 1){
             $(this).attr('data-qty0', qty1);
           }   
           $(this).attr('data-id0', vid0);
          } 
        });
      }
    }

    if(hasProgressbar == "true" && count == included){
      new_price = parseFloat(var_price).toFixed(2);
      total_price = new_price;
      var currency_symbol = 'CHF';
      $(".customize-product-price-grid .customize_product_price").html(currency_symbol+new_price);
    }else if(total > free_stone){
      if (hasProgressbar == "true"){
        if(count < parseInt(included) + parseInt(free_stone_1)){
          free_extra_stones = 0;
        }else if(count < parseInt(included) + parseInt(free_stone_1) + parseInt(free_stone_2)){
          free_extra_stones = 1;
        }
      }
      var new_total = parseFloat(total) - parseFloat(free_stone) - parseFloat(free_extra_stones);
      var stone_price = parseFloat(new_total) * parseFloat(single_stone_price);
      var new_price = (parseFloat(stone_price) + parseFloat(var_price)).toFixed(2);
      total_price = new_price;
      var currency_symbol = 'CHF';
      $(".customize-product-price-grid .customize_product_price").html(currency_symbol+new_price);
      
    }else{
      new_price = var_price;
      var currency_symbol = 'CHF';
      $(".customize-product-price-grid .customize_product_price").html(currency_symbol+new_price);
    }
  });


  /*********************************** For Adding Selected Stone ************************************************/
  $(document).on("click", ".selected_stone li .plus_", function (){
    var total = 0;
    var check_current_quan = '';

    var data_name = $(this).closest('li').attr('class');
    
    $(".selected_stone li .quan_").each(function(){
      total = parseFloat(total) + parseFloat($(this).html());
    });

    count += 1;
    if (hasProgressbar == "true") {
      renderProgressAdd();
      renderPopup();
    }

    if(total < free_stone){
      var old_val = $(this).parent().find(".quan_").html();
      var new_quan = parseFloat(old_val) + 1;
      $(this).closest(".stone_quan").find(".quan_").html(new_quan);

      $('.customize-base-grid .selected_stone li').each(function(){
        var name = $(this).attr('class');
        var qty0 = $(this).attr('data-qty0');
        var qty1 = $(this).attr('data-qty1');
      
        if(data_name == name){
          var vid0 = ''; 
          $('.customize-base-grid .customize-box').each(function(){
            if($(this).find('.customize-addon-label').attr('data-handle') == data_name){
              vid0 = $(this).find('.customize-addon-variants li input[data-price-zero]').val();
            }
          }) 
          var updated_qty0;
          if(qty0 > 0){
            updated_qty0 = parseInt(qty0)+parseInt(1);
            $(this).attr('data-qty0',updated_qty0);
          }else{
            updated_qty0 = 1;
            $(this).attr('data-id0',vid0);
            $(this).attr('data-qty0',updated_qty0);
          }
        }
      })
      
    }else{
      var old_val = $(this).parent().find(".quan_").html();
      var new_quan = parseFloat(old_val) + 1;
      $(this).closest(".stone_quan").find(".quan_").html(new_quan);
      var name = $(this).closest('li').attr('class');
      var var_price = 0;
      var base_price = $(".customize_product_base .customize-base-box.is-selected").find('input[type="radio"]').attr('data-price');
      var_price = base_price;
      // var var_price = $(".customize-product-price-grid .customize_product_price").attr("data-base-price");

      var check_if_id_exists0 = $(this).closest('li').attr('data-id0');
      var check_if_id_exists1 = $(this).closest('li').attr('data-id1');
      var check_if_qty0 = $(this).closest('li').attr('data-qty0');
      var check_if_qty1 = $(this).closest('li').attr('data-qty1');
      
      total = parseFloat(total) + 1;
      if(hasProgressbar == "true"){
        if(count >= parseInt(included) + parseInt(free_stone_1) + parseInt(free_stone_2)){
          free_extra_stones = 2;
        }else if(count >= parseInt(included) + parseInt(free_stone_1)){
          free_extra_stones = 1;
        }
      }

      $('.customize-base-grid .selected_stone li').each(function(){
        var name = $(this).attr('class');
        var qty0 = $(this).attr('data-qty0');
        var qty1 = $(this).attr('data-qty1');

        if(data_name == name){
          if(count == parseInt(included) + parseInt(free_stone_1)){
            var vid0 = ''; var vid1 = '';
            $('.customize-base-grid .customize-box').each(function(){
              if($(this).find('.customize-addon-label').attr('data-handle') == data_name){
                vid0 = $(this).find('.customize-addon-variants li input[data-price-zero]').val();
                vid1 = $(this).find('.customize-addon-variants li input[data-price-not-zero]').val();
              }
            }) 
            var updated_qty0; var updated_qty1;
            if(qty0 > 0){
              updated_qty0 = parseInt(qty0)+parseInt(1);
              $(this).attr('data-qty0',updated_qty0);
            }else{
              updated_qty0 = 1;
              $(this).attr('data-id0',vid0);
              $(this).attr('data-qty0',updated_qty0);
            }
          }else if(count == parseInt(included) + parseInt(free_stone_1) + parseInt(free_stone_2)){
            var vid0 = ''; var vid1 = '';
            $('.customize-base-grid .customize-box').each(function(){
              if($(this).find('.customize-addon-label').attr('data-handle') == data_name){
                vid0 = $(this).find('.customize-addon-variants li input[data-price-zero]').val();
                vid1 = $(this).find('.customize-addon-variants li input[data-price-not-zero]').val();
              }
            }) 
            var updated_qty0; var updated_qty1;
            if(qty0 > 0){
              updated_qty0 = parseInt(qty0)+parseInt(1);
              $(this).attr('data-qty0',updated_qty0);
            }else{
              updated_qty0 = 1;
              $(this).attr('data-id0',vid0);
              $(this).attr('data-qty0',updated_qty0);
            }
          }else{
            var vid0 = ''; var vid1 = '';
            $('.customize-base-grid .customize-box').each(function(){
              if($(this).find('.customize-addon-label').attr('data-handle') == data_name){
                vid0 = $(this).find('.customize-addon-variants li input[data-price-zero]').val();
                vid1 = $(this).find('.customize-addon-variants li input[data-price-not-zero]').val();
              }
            }) 
            var updated_qty0; var updated_qty1;
            if(qty1 > 0){
              updated_qty1 = parseInt(qty1)+parseInt(1);
              $(this).attr('data-qty1',updated_qty1);
            }else{
              updated_qty1 = 1;
              $(this).attr('data-id1',vid1);
              $(this).attr('data-qty1',updated_qty1);
            }
          }
        }
      })
    
      var new_total = parseFloat(total) - parseFloat(free_stone) - parseFloat(free_extra_stones);
      var stone_price = parseFloat(new_total) * parseFloat(single_stone_price);
      var new_price = (parseFloat(stone_price) + parseFloat(var_price)).toFixed(2);
      total_price = new_price;
      var currency_symbol = 'CHF';
      $(".customize-product-price-grid .customize_product_price").html(currency_symbol+new_price);
    }
    
  });


  // Atc when progressbar cart icon is clicked
   $(document).on("click", "button.checkoutButton",function(e){
    e.preventDefault();
    var stone_selected = 0;
	var no_stone_selected = 0;

    $('.customize-base-grid .customize-box').each(function(){
		if($(this).hasClass('no-stone')){
			not_stone_selected = 1;
		}else{
			if($(this).find('.customize-addon-label').hasClass('active')){
				no_stone_selected = 0;
				stone_selected += 1;
			}
		}
    })
    
    if(!cage_selected && no_stone_selected == 0){
      alert(alThemeString('alunirCustomizeSamePriceAlert', 'Du kannst f\u00FCr den gleichen Preis vier magische Anh\u00E4nger hinzuf\u00FCgen'));
    }else{
      var current_selected_variant = $('.customize_product_base .customize-base-box input[type="radio"]:checked').val();
      var current_variant_qty = 1;
      var customize_addons_arr = [];
      var jsonObjp = localStorage.getItem("customize_product_data");
      if(jsonObjp == '' || jsonObjp == null || jsonObjp == 'undefiend'){
        var jsonObj = [];
      }else{
         var jsonObj = JSON.parse(jsonObjp);
      }       
      $('.customize-base-grid .selected_stone li').each(function(){
        var free_product_id = $(this).attr('data-id0');
        var paid_product_id = $(this).attr('data-id1');
        var free_product_qty = $(this).attr('data-qty0');
        var paid_product_qty = $(this).attr('data-qty1');

        if(typeof(free_product_id) != 'undefined' && free_product_id != ''){
          customize_addons_arr.push({'id':free_product_id,'quantity':free_product_qty});
        }
        if(typeof(paid_product_id) != 'undefined' && paid_product_id != ''){
          customize_addons_arr.push({'id':paid_product_id,'quantity':paid_product_qty});
        }
      })

      console.log(customize_addons_arr);
      console.log(current_selected_variant);

      if(current_selected_variant != '' && current_selected_variant != 'undefined'){
        customize_addons_arr.push({'id':current_selected_variant, 'quantity': '1'});
        jsonObj.push({'product_id':current_selected_variant, 'items': customize_addons_arr});
      }
      if(customize_addons_arr != ''){
        localStorage.setItem("customize_product_data",JSON.stringify(jsonObj)); 
        // const data = localStorage.getItem("customize_product_data");
        // console.log("data: ", JSON.parse(data));
        let formData = {
         'items': customize_addons_arr
        };
        fetch(window.Shopify.routes.root + 'cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(formData)
        })
        .then(response => {
          return response.json();
        })
        .then(response => {
          var cart = new theme.CartDrawer
          cart.init()
          cart.open();
        })
        .catch((error) => {
          console.error('Error:', error);
        });

      } 
    } 
  })
  

   // Atc when main add to cart button is clicked
  $(document).on('click','.product-block[data-id="customize-template-grid"] .product-single__form button[data-add-to-cart]',function(e){
    e.preventDefault();
    e.stopPropagation();
    var stone_selected = 0;
	var no_stone_selected = 0;

    $('.customize-base-grid .customize-box').each(function(){
		if($(this).hasClass('no-stone')){
			not_stone_selected = 1;
		}else{
			if($(this).find('.customize-addon-label').hasClass('active')){
				not_stone_selected = 0;
				stone_selected += 1;
			}
		}
    })
    
    if(!cage_selected && no_stone_selected == 0){
      alert(alThemeString('alunirCustomizeSamePriceAlert', 'Du kannst f\u00FCr den gleichen Preis vier magische Anh\u00E4nger hinzuf\u00FCgen'));
    }else{
      var current_selected_variant = $('.customize_product_base .customize-base-box input[type="radio"]:checked').val();
      var current_variant_qty = 1;
      var customize_addons_arr = [];
      var jsonObjp = localStorage.getItem("customize_product_data");
      if(jsonObjp == '' || jsonObjp == null || jsonObjp == 'undefiend'){
        var jsonObj = [];
      }else{
         var jsonObj = JSON.parse(jsonObjp);
      } 
      
      $('.customize-base-grid .selected_stone li').each(function(){
        var free_product_id = $(this).attr('data-id0');
        var paid_product_id = $(this).attr('data-id1');
        var free_product_qty = $(this).attr('data-qty0');
        var paid_product_qty = $(this).attr('data-qty1');

        if(typeof(free_product_id) != 'undefined' && free_product_id != ''){
          customize_addons_arr.push({'id':free_product_id,'quantity':free_product_qty});
        }
        if(typeof(paid_product_id) != 'undefined' && paid_product_id != ''){
          customize_addons_arr.push({'id':paid_product_id,'quantity':paid_product_qty});
        }
      })

      if(current_selected_variant != '' && current_selected_variant != 'undefined'){
        customize_addons_arr.push({'id':current_selected_variant, 'quantity': '1'});
        jsonObj.push({'product_id':current_selected_variant, 'items': customize_addons_arr});
      }
      if(customize_addons_arr != ''){
        localStorage.setItem("customize_product_data",JSON.stringify(jsonObj)); 
        let formData = {
         'items': customize_addons_arr
        };
        fetch(window.Shopify.routes.root + 'cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(formData)
        })
        .then(response => {
          return response.json();
        })
        .then(response => {
          var cart = new theme.CartDrawer
          cart.init()
          cart.open();
        })
        .catch((error) => {
          console.error('Error:', error);
        });

      } 
    } 
  })


  // Removing product with stones from minicart on clicking minus icon
  $(document).on('click', '#CartDrawerForm .cart__item[data-tag="Customize Product"] .cart__item-sub .js-qty__wrapper button.js-qty__adjust.js-qty__adjust--minus', function(){
    var current_qty = $(this).closest('.js-qty__wrapper').find('input[type="text"]').val();
    var current_product_addons = $(this).closest('.cart__item').attr('data-addons');
    var product_id = $(this).closest('.cart__item').attr('data-pid');
   
    if(current_product_addons != ''){
      const data = localStorage.getItem("customize_product_data");
      var items_data = '';
      var obj = [];
      if(data != null && data != '' && data != 'undefiend'){
        var pp = JSON.parse(data);
        for (let i = 0; i < pp.length; i++) {
          if(pp[i].product_id == product_id){
            if(items_data != null && items_data != '' && items_data != 'undefiend'){
              obj.push({'product_id':product_id, 'items': items_data});
            }
            items_data = pp[i].items;
          }else{
            obj.push({'product_id':pp[i].product_id, 'items': pp[i].items});
          }
        }
      }

      var found = 0;
      $('#CartDrawerForm .cart__item[data-tag="Customize Product"]').each(function(){
        found = parseInt(found)+parseInt(1);
      })
      
      /* if($('#CartDrawerForm .cart__items .cart__item[data-pid="45537035780376"]').length){
         found = parseInt(found)+1;
      }
      if($('#CartDrawerForm .cart__items .cart__item[data-pid="45537035813144"]').length){
         found = parseInt(found)+1;
      } */
      
      setTimeout(function(){
        if(current_qty == 0 && found == 1){
          var formData = {};
          var updates = {};
          var updates_arr = [];
          $('#CartDrawerForm .cart__items .cart__item').each(function(){
            var pname = $(this).attr('data-pname');
            var ppid = $(this).attr('data-pid');
            if($(this).attr('data-tag') == 'Customize Addon'){
               var data_key = $(this).attr('data-key');
               var key_arr = data_key.split(':');
               var k = key_arr[0];
               updates[k] = 0;
            }
          })
          
          localStorage.setItem("customize_product_data",''); 
          setTimeout(function(){
            formData = {updates};
            jQuery.ajax({
              type: 'POST',
              url: '/cart/update.js',
              data: formData,
              dataType: 'json',
              success: function(data) {
                var cart = new theme.CartDrawer
                cart.init()
              },
              error: function (request, status, error) {
                alert(request.responseText);
              }
            }); 
          },500);
  
        }else{
          var formData = {};
          var updates = {};
          var updates_arr = [];
          $('#CartDrawerForm .cart__items .cart__item').each(function(){
            var pname = $(this).attr('data-pname');
            var ppid = $(this).attr('data-pid');
            var quan = $(this).find('input.js-qty__num').val();
            var data_key = $(this).attr('data-key');
            if($(this).attr('data-tag') == 'Customize Addon'){
              if(items_data != null && items_data != '' && items_data != 'undefiend'){
                for (let i = 0; i < items_data.length; i++) {
                  if(items_data[i].id == ppid){                   
                    var new_quan = parseInt(quan) - parseInt(items_data[i].quantity);                    
                    var key_arr = data_key.split(':');
                    var k = key_arr[0];
                    updates[k] = new_quan;
                    break;
                  }
                }
              }
            }
          })
          localStorage.setItem("customize_product_data",JSON.stringify(obj)); 
          setTimeout(function(){
            formData = {updates};
            console.log(formData);
            jQuery.ajax({
              type: 'POST',
              url: '/cart/update.js',
              data: formData,
              dataType: 'json',
              success: function(data) {
                var cart = new theme.CartDrawer
                cart.init()
              },
              error: function (request, status, error) {
                alert(request.responseText);
              }
            }); 
          },500);
        } 
      }, 1000);  
    }
  });   


  // Removing product with stones from cart page on clicking minus icon
  $(document).on('click', '#CartPageForm .cart__item[data-tag="Customize Product"] .cart__item-sub .js-qty__wrapper button.js-qty__adjust.js-qty__adjust--minus', function(){
    var current_qty = $(this).closest('.js-qty__wrapper').find('input[type="text"]').val();
    var current_product_addons = $(this).closest('.cart__item').attr('data-addons');
    var product_id = $(this).closest('.cart__item').attr('data-pid');
    
    if(current_product_addons != ''){
      const data = localStorage.getItem("customize_product_data");
      var items_data = '';
      var obj = [];
      if(data != null && data != '' && data != 'undefiend'){
        var pp = JSON.parse(data);
        for (let i = 0; i < pp.length; i++) {
          if(pp[i].product_id == product_id){
            if(items_data != null && items_data != '' && items_data != 'undefiend'){
              obj.push({'product_id':product_id, 'items': items_data});
            }
            items_data = pp[i].items;
          }else{
            obj.push({'product_id':pp[i].product_id, 'items': pp[i].items});
          }
        }
      }

      var found = 0;
      $('#CartPageForm .cart__item[data-tag="Customize Product"]').each(function(){
        found = parseInt(found)+parseInt(1);
      })
      /* if($('#CartPageForm .cart__page .cart__item[data-pid="45537035780376"]').length){
         found = parseInt(found)+1;
      }
      if($('#CartPageForm .cart__page .cart__item[data-pid="45537035813144"]').length){
         found = parseInt(found)+1;
      } */
      setTimeout(function(){
        if(current_qty == 0 && found == 1){
          var formData = {};
          var updates = {};
          var updates_arr = [];
          $('#CartPageForm .cart__page .cart__item').each(function(){
            var pname = $(this).attr('data-pname');
            var ppid = $(this).attr('data-pid');
            if($(this).attr('data-tag') == 'Customize Addon'){
              var data_key = $(this).attr('data-key');
               var quan = $(this).find('input.js-qty__num').val();
               var key_arr = data_key.split(':');
               var k = key_arr[0];
               updates[k] = 0;
            }
          })
          localStorage.setItem("customize_product_data",''); 
          setTimeout(function(){
            formData = {updates};
            jQuery.ajax({
              type: 'POST',
              url: '/cart/update.js',
              data: formData,
              dataType: 'json',
              success: function(data) {
                 location.reload();
              },
              error: function (request, status, error) {
                alert(request.responseText);
              }
            }); 
          },500);
        }else{
          var formData = {};
          var updates = {};
          var updates_arr = [];
          $('#CartPageForm .cart__page .cart__item').each(function(){
            var pname = $(this).attr('data-pname');
            var ppid = $(this).attr('data-pid');
            var quan = $(this).find('input.js-qty__num').val();
            var data_key = $(this).attr('data-key');
            if($(this).attr('data-tag') == 'Customize Addon'){
              if(items_data != null && items_data != '' && items_data != 'undefiend'){
                for (let i = 0; i < items_data.length; i++) {
                  if(items_data[i].id == ppid){                   
                    var new_quan = parseInt(quan) - parseInt(items_data[i].quantity);                    
                    var key_arr = data_key.split(':');
                    var k = key_arr[0];
                    updates[k] = new_quan;
                    break;
                  }
                }
              }
            }
          })
          localStorage.setItem("customize_product_data",JSON.stringify(obj)); 
          setTimeout(function(){
            formData = {updates};
            console.log(formData);
            jQuery.ajax({
              type: 'POST',
              url: '/cart/update.js',
              data: formData,
              dataType: 'json',
              success: function(data) {
                location.reload();
              },
              error: function (request, status, error) {
                alert(request.responseText);
              }
            }); 
          },500);
        } 
      }, 1000);
    }
  });  


  // Removing item from cart 
  $(document).on('click','form#CartPageForm .cart__item[data-tag="Customize Product"] .cart__remove a',function(e){
    e.preventDefault();
    var current_data_key = $(this).closest('.cart__item').attr('data-key');
    var current_key_arr = [];
    current_key_arr = current_data_key.split(':');
    var current_id = current_key_arr[0];
    var current_product_addons = $(this).closest('.cart__item').attr('data-addons');
    if(current_product_addons != ''){
      setTimeout(function(){
        var formData = {};
        var updates = {};
        var updates_arr = [];
        $('#CartPageForm .cart__page .cart__item').each(function(){
          var pname = $(this).attr('data-pname');
          if($(this).attr('data-tag') == 'Customize Addon'){
            if(pname != '' && pname != 'undefined' && pname != null){
              if(current_product_addons.includes(pname) == true){
                var data_key = $(this).attr('data-key');
                var key_arr = data_key.split(':');
                var k = key_arr[0];
                updates[k] = 0;
              }
            }
          }
        })
        if(current_id != '' && current_id != 'undefined' && current_id != null){
           updates[current_id] = 0;
        }
        formData = {updates};
        jQuery.ajax({
          type: 'POST',
          url: '/cart/update.js',
          data: formData,
          dataType: 'json',
          success: function(data) {
            location.reload();
          },
          error: function (request, status, error) {
            alert(request.responseText);
          }
        });  
      }, 1000); 
    } 
  })
  
  /*********************** Customize Product End ***********************/
  
})
